<!-- Step.vue  -->
<template>
	<div class="stepOut">
		<ul style="list-style: none;display: flex;width: 100%;flex-direction: column;">
			<li class="stepItem" v-for="(stepItem, index) in stepInfo.list" :key="index">
				<!-- 模拟步骤条的节点，此处为圆圈 -->
				<div :class="stepInfo.step >= index+1 ? index=='0'?'icon active':index=='1'?'icon active1':'icon active2' :'icon'"></div>
				<!-- 模拟步骤条连接线，动态显示  -->
				<div :class="stepInfo.step >= index+2 ? index=='0'?'line lineActive':'line lineActive1':'line'"
					:style="index!==stepInfo.list.length-1?'':'height:60%'"></div>
				<!-- 步骤名称  -->
				<div :class="stepInfo.step >= index+1 ?  index=='0'?'stepStatus':index=='1'?'stepStatus1':'stepStatus2' :'stepStatus3'">{{stepItem.name}}</div>
			</li>
		</ul>
	</div>
</template>
 
<script>
	export default {
		name: 'steps',
		props: {
			// 传递步骤参数
			stepInfo: {
				type: Object,
				default: function() {
					return {
						list: [],
						step: 0
					}
				}
			}
		}
	}
</script>
 
<style scoped>
	.stepOut {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
 
	/* 两点间间距 */
	.stepOut .stepItem {
		height: 100px;
		float: left;
		font-size: 16px;
		position: relative;
	}
 
	.stepOut .stepItem .icon {
        width: 24px;
height: 24px;
background: #171D2F;
opacity: 1;
border: 4px solid #606988;
		border-radius: 50%;
		/* margin: 0 auto; */
		position: relative;
		z-index: 888;
	}
 
	.stepOut .stepItem .active {
        position: relative;
        left: -7px;
		width: 36px;
height: 36px;
background: #171D2F;

border: 6px solid #5780FF;
	}
	.stepOut .stepItem .active1 {
		width: 24px;
height: 24px;
background: #171D2F;

background: #171D2F;
opacity: 1;
border: 4px solid #606988;
	}
	.stepOut .stepItem .active2 {
		background-color: #02C6A3;
	}
	/* 线条 */
	.stepOut .stepItem .line {
		position: absolute;
        width: 100%;
        height: 100%;
		top: 11px;
		left: 10px;
		border-left: 2px solid rgba(84,114,206,0.2);;
		width: 100%;
		z-index: 111;
        margin-bottom: 20px;
	}
 
	.stepOut .stepItem .lineActive {
        
        border-left: 2px solid rgba(84,114,206,0.2);;

      
	}
    .lineActive::after{
        position: relative;
        left: -2px;
        display: block;
        content: attr(alt);
        height: 50%;
		border-left: 2px solid #5780FF ;
            
        }
	.stepOut .stepItem .lineActive1{
		border-bottom: 2px solid #02C6A3  ;
	}
	/* 下面字体颜色 */
	.stepOut .stepItem .stepStatus {
        margin-left: 20px;
height: 50px;
line-height: 50px;
text-align: center;
background: #ffffff0a;
border-radius: 12px 12px 12px 12px;

font-size: 12px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #D1D1D1;
	}
	.stepOut .stepItem .stepStatus1 {
        margin-left: 20px;
height: 50px;
line-height: 50px;
text-align: center;
background: #ffffff0a;
border-radius: 12px 12px 12px 12px;

font-size: 12px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #D1D1D1;
	}
	.stepOut .stepItem .stepStatus2 {
        margin-left: 20px;
height: 50px;
line-height: 50px;
text-align: center;
background: #ffffff0a;
border-radius: 12px 12px 12px 12px;

font-size: 12px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #D1D1D1;
	}
	.stepOut .stepItem .stepStatus3 {
        margin-left: 20px;
height: 50px;
line-height: 50px;
text-align: center;
background: #ffffff0a;
border-radius: 12px 12px 12px 12px;

font-size: 12px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #D1D1D1;
	}
</style>